import React from 'react';
import styles from './loader.module.scss'
import {Spin} from "antd";

interface Props {
  loading: boolean
}

const Loader = ({loading}: Props) => {

  return (
    <div className={styles.container}>
      {
        loading &&
        <div className={styles.content}>
          <div className={styles.wrap}>
            <Spin size="small"/>
          </div>
        </div>
      }
    </div>
  );
};

export default Loader;